/* RILLWAG storefront interactions. No customer eligibility or discount enforcement is attempted in the browser. */
(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  /* Option names in English on the storefront, whatever they are called in the admin (e.g. a Chinese size option name becomes Size). */
  const optionLabel=name=>{const n=String(name||'').trim().toLowerCase();
    if(/^(size|sizes|dog size|\u5c3a\u5bf8|\u5c3a\u7801|\u5c3a\u78bc|\u5927\u5c0f|\u7801\u6570|\u78bc\u6578|\u7801|\u78bc|\u89c4\u683c|\u898f\u683c|\u578b\u53f7|\u578b\u865f)$/.test(n))return 'Size';
    if(/^(colou?rs?|colourway|\u989c\u8272|\u984f\u8272|\u8272|\u989c\u8272\u5206\u7c7b|\u984f\u8272\u5206\u985e)$/.test(n))return 'Colour';
    return /[\u2E80-\u9FFF\uF900-\uFAFF\uFF00-\uFFEF]/.test(n)?'Option':String(name||'');};

  /* Transparent product photos: find where the product actually is in the PNG and zoom it to fill its frame,
     however much empty space the file has around it. Falls back to the plain image if the file can't be read. */
  const fitBoxes=new Map();
  const fitKey=src=>{try{const u=new URL(src,location.href);u.searchParams.delete('width');u.searchParams.delete('height');return u.toString();}catch{return src;}};
  function cutoutBox(src){
    const key=fitKey(src);
    if(fitBoxes.has(key))return fitBoxes.get(key);
    const p=new Promise(res=>{
      const probe=new Image();probe.crossOrigin='anonymous';probe.decoding='async';
      let url=src;try{const u=new URL(src,location.href);if(u.search||/cdn\/shop|cdn\.shopify/.test(u.href)){u.searchParams.set('width','320');}url=u.toString();}catch{}
      probe.onload=()=>{try{
        const w=probe.naturalWidth,h=probe.naturalHeight;if(!w||!h)return res(null);
        const c=document.createElement('canvas');c.width=w;c.height=h;const ctx=c.getContext('2d',{willReadFrequently:true});ctx.drawImage(probe,0,0);
        const d=ctx.getImageData(0,0,w,h).data;let x0=w,y0=h,x1=-1,y1=-1;
        for(let y=0;y<h;y++){const row=y*w*4;for(let x=0;x<w;x++){if(d[row+x*4+3]>16){if(x<x0)x0=x;if(x>x1)x1=x;if(y<y0)y0=y;if(y>y1)y1=y;}}}
        if(x1<0)return res(null);
        res({x0:x0/w,y0:y0/h,x1:(x1+1)/w,y1:(y1+1)/h,ar:w/h});
      }catch{res(null);}};
      probe.onerror=()=>res(null);probe.src=url;
    });
    fitBoxes.set(key,p);return p;
  }
  function fitImage(img,margin){
    const src=img.currentSrc||img.src;if(!src)return;
    if(!img.classList.contains('is-fitted'))img.classList.add('rw2-fit-pending');
    cutoutBox(src).then(b=>{
      img.classList.remove('rw2-fit-pending');
      if(!b)return;
      const cs=getComputedStyle(img),pl=parseFloat(cs.paddingLeft)||0,pr=parseFloat(cs.paddingRight)||0,pt=parseFloat(cs.paddingTop)||0,pb=parseFloat(cs.paddingBottom)||0;
      const fw=img.clientWidth,fh=img.clientHeight;if(!fw||!fh)return;
      const iw=fw-pl-pr,ih=fh-pt-pb;if(iw<=0||ih<=0)return;
      let dw,dh;if(iw/ih>b.ar){dh=ih;dw=ih*b.ar;}else{dw=iw;dh=iw/b.ar;}
      const ox=pl+(iw-dw)/2,oy=pt+(ih-dh)/2,bw=(b.x1-b.x0)*dw,bh=(b.y1-b.y0)*dh;if(bw<1||bh<1)return;
      const cx=ox+(b.x0+b.x1)/2*dw,cy=oy+(b.y0+b.y1)/2*dh;
      let s=Math.min(iw*(1-2*margin)/bw,ih*(1-2*margin)/bh);s=Math.max(1,Math.min(s,2.6));
      img.style.transformOrigin='0 0';img.style.transform=`translate(${(pl+iw/2-s*cx).toFixed(2)}px,${(pt+ih/2-s*cy).toFixed(2)}px) scale(${s.toFixed(4)})`;
      img.classList.add('is-fitted');
    });
  }
  function fitCutouts(root=document){
    $$('[data-rw2-fit]',root).forEach(box=>{
      const margin=parseFloat(box.dataset.rw2FitMargin)||0.05;
      $$(':scope > .rw2-media img, :scope > img',box).forEach(img=>{
        if(!img.clientWidth)return;
        if(img.complete&&img.naturalWidth)fitImage(img,margin);
        else img.addEventListener('load',()=>fitImage(img,margin),{once:true});
      });
    });
  }
  window.RW2FitCutouts=fitCutouts;
  let fitTimer;window.addEventListener('resize',()=>{clearTimeout(fitTimer);fitTimer=setTimeout(()=>fitCutouts(),150);});
  window.addEventListener('load',()=>fitCutouts());
  const memory = new Map();
  const storage = (kind, key, value) => {
    const cacheKey = `${kind}:${key}`;
    try { const store = window[kind]; if (value !== undefined) store.setItem(key, value); return store.getItem(key); }
    catch { if (value !== undefined) memory.set(cacheKey, value); return memory.get(cacheKey); }
  };
  const openDialog = (id, trigger) => {
    const dialog = document.getElementById(id);
    if (!dialog || dialog.open) return;
    $$('dialog[open]').forEach(d => d.close());
    dialog._rw2Trigger = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    if (id === 'rw2-menu') $('[data-rw2-mega]')?.removeAttribute('open');
  };
  function initDialogs(root = document) {
    $$('dialog.rw2-dialog', root).forEach(dialog => {
      if (dialog.dataset.rw2Ready) return;
      dialog.dataset.rw2Ready = 'true';
      dialog.addEventListener('close', () => {
        if (!$('dialog[open]')) document.documentElement.style.overflow = '';
        if (dialog._rw2Trigger?.isConnected) dialog._rw2Trigger.focus({preventScroll:true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const r = dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) dialog.close();
      });
    });
  }
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-rw2-open]');
    if (opener) { event.preventDefault(); openDialog(opener.dataset.rw2Open, opener); }
    const closer = event.target.closest('[data-rw2-close]');
    if (closer) { event.preventDefault(); closer.closest('dialog')?.close(); }
    const sizeLink = event.target.closest('a[href="/pages/size-fit"]');
    if (sizeLink && $('#rw2-size')) { event.preventDefault(); openDialog('rw2-size', sizeLink); }
    const compare = event.target.closest('[data-rw2-compare]');
    if (compare) {
      const pressed = compare.getAttribute('aria-pressed') !== 'true';
      compare.setAttribute('aria-pressed', String(pressed));
      const altImage = $('.rw2-compare-image', compare.parentElement);
      if (altImage) altImage.hidden = !pressed;
      compare.textContent = pressed ? 'VIEW IN DAYLIGHT' : 'VIEW IN LOW LIGHT';
    }
  });
  function initHeader() {
    const header = $('[data-rw2-header]');
    if (!header || header.dataset.rw2Ready) return;
    header.dataset.rw2Ready = 'true';
    // Horizon scrolls inside .page-wrapper on desktop (window.scrollY stays 0), so read whichever element scrolls.
    const scroller = document.querySelector('.page-wrapper');
    const offset = () => Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, scroller ? scroller.scrollTop : 0);
    // Hide on scroll down, reveal (on brand green) on scroll up, transparent again at the very top of the home page.
    const section = header.closest('.shopify-section') || header;
    const megaMenu = $('[data-rw2-mega]', header);
    const setHidden = hidden => { header.classList.toggle('is-hidden', hidden); section.classList.toggle('rw2-header-hidden', hidden); };
    let ticking = false, last = offset();
    const update = () => {
      ticking = false;
      const y = offset(), delta = y - last;
      header.classList.toggle('is-scrolled', y > 28);
      if (y <= header.offsetHeight + 40) { setHidden(false); last = y; return; }
      if (delta > 8) { if (!(megaMenu && megaMenu.open) && !header.contains(document.activeElement)) setHidden(true); last = y; }
      else if (delta < -8) { setHidden(false); last = y; }
    };
    const request = () => { if (!ticking) { ticking = true; requestAnimationFrame(update); } };
    window.addEventListener('scroll', request, {passive:true});
    document.addEventListener('scroll', request, {passive:true, capture:true});
    update();
    const mega = $('[data-rw2-mega]', header);
    if (!mega) return;
    let leave;
    mega.addEventListener('pointerenter', e => { if(e.pointerType === 'mouse') { clearTimeout(leave); mega.open = true; } });
    mega.addEventListener('pointerleave', e => { if(e.pointerType === 'mouse') leave = setTimeout(() => {if(!mega.contains(document.activeElement)) mega.open=false;},160); });
    mega.addEventListener('keydown', e => { if(e.key==='Escape'){mega.open=false;$('summary',mega).focus();} });
    mega.addEventListener('focusout', () => setTimeout(() => {if(!mega.contains(document.activeElement)) mega.open=false;},0));
    document.addEventListener('click', e => {if(!mega.contains(e.target)) mega.open=false;});
  }
  let revealObserver;
  function initReveals(root=document) {
    if (reduced.matches || $('script[data-rw2-motion]')?.dataset.rw2Motion === 'false' || window.Shopify?.designMode || !('IntersectionObserver' in window)) return;
    document.documentElement.classList.add('rw2-reveal-enabled');
    revealObserver ||= new IntersectionObserver(entries => entries.forEach(entry => {
      if(entry.isIntersecting) { entry.target.classList.add('is-visible'); revealObserver.unobserve(entry.target); }
    }), {threshold:.08,rootMargin:'0px 0px 25px 0px'});
    $$('[data-rw2-reveal]',root).forEach((el,i) => {el.style.setProperty('--rw2-delay',`${i%4*100}ms`);revealObserver.observe(el);});
  }
  const colourMeta = value => {
    const raw = String(value || ''), v=raw.toLowerCase();
    if (['stone','silver','silver grey','silver gray','grey','gray'].includes(v)) return {name:'STONE',description:'Silver Grey',swatch:'#a5a8a8',aliases:['stone','silver','silver grey','silver gray','grey','gray']};
    if (['moorland','olive','burnt olive','green'].includes(v)) return {name:'MOORLAND',description:'Burnt Olive',swatch:'#77765b',aliases:['moorland','olive','burnt olive','green']};
    if (['cloud','white','cloud dancer','off white'].includes(v)) return {name:'CLOUD',description:'Cloud Dancer',swatch:'#eceae3',aliases:['cloud','white','cloud dancer','off white']};
    return {name:raw.toUpperCase(),description:'',swatch:'#c8ccc6',aliases:[v]};
  };
  function initProduct(root=document) {
    $$('[data-rw2-product]',root).forEach(component => {
      if(component.dataset.rw2Ready) return;
      const payload=$('[data-rw2-product-json]',component);
      if(!payload) return;
      let product;try{product=JSON.parse(payload.textContent);}catch{return;}
      if(!Array.isArray(product.variants) || !product.variants.length) return;
      component.dataset.rw2Ready='true';
      const variants=product.variants;
      const colorIndex=Number(component.dataset.colorIndex), sizeIndex=Number(component.dataset.sizeIndex);
      const initial=variants.find(v=>String(v.id)===component.dataset.initialVariant)||variants[0];
      const groups=$$('[data-rw2-option]',component);
      const selection=new Array(product.options.length).fill(null);
      if(colorIndex>=0) selection[colorIndex]=initial.options[colorIndex];
      // A product with one default variant has no customer-selectable options.
      if(!groups.length) initial.options.forEach((v,i)=>selection[i]=v);
      const form=$('form.rw2-buy-form',component), variantInput=$('[data-rw2-variant]',component);
      const addButton=$('[data-rw2-add]',component), error=$('[data-rw2-selection-error]',component), stock=$('[data-rw2-stock]',component);
      const pre=component.dataset.prelaunch==='true';
      const formatter=new Intl.NumberFormat(component.dataset.locale||'en-GB',{style:'currency',currency:component.dataset.currency||'GBP'});
      const money=cents=>formatter.format(cents/100);
      let chosen=null, busy=false, galleryIndex=0, galleryItems=[];
      // Thumbnail strip: stays inside the gallery, fades at whichever edge has more thumbnails, and keeps the active one in view.
      const thumbRow=$('.rw2-gallery-thumbs',component);
      const thumbFade=()=>{if(!thumbRow)return;const more=thumbRow.scrollWidth-thumbRow.clientWidth;thumbRow.classList.toggle('has-more-left',more>2&&thumbRow.scrollLeft>2);thumbRow.classList.toggle('has-more-right',more>2&&more-thumbRow.scrollLeft>2);};
      const revealThumb=index=>{
        if(!thumbRow)return;const button=thumbRow.children[index];
        if(button&&thumbRow.scrollWidth>thumbRow.clientWidth){
          const pad=Math.min(56,thumbRow.clientWidth/4),left=button.offsetLeft,right=left+button.offsetWidth;let target=null;
          if(left-pad<thumbRow.scrollLeft)target=Math.max(0,left-pad);
          else if(right+pad>thumbRow.scrollLeft+thumbRow.clientWidth)target=right+pad-thumbRow.clientWidth;
          if(target!==null)thumbRow.scrollTo({left:target,behavior:reduced.matches?'auto':'smooth'});
        }
        requestAnimationFrame(thumbFade);
      };
      thumbRow?.addEventListener('scroll',thumbFade,{passive:true});window.addEventListener('resize',thumbFade);
      const allSlides=$$('[data-rw2-gallery-item]',component);
      function pauseSlide(slide) {$$('video',slide).forEach(v=>v.pause());}
      function showSlide(index) {
        if(!galleryItems.length) return;
        galleryIndex=(index+galleryItems.length)%galleryItems.length;
        allSlides.forEach(slide=>{const hidden=slide!==galleryItems[galleryIndex];slide.hidden=hidden;if(hidden)pauseSlide(slide);});
        $('[data-rw2-gallery-count]',component).textContent=`${galleryIndex+1} / ${galleryItems.length}`;
        $$('.rw2-gallery-thumbs button',component).forEach((button,i)=>button.setAttribute('aria-pressed',String(i===galleryIndex)));
        revealThumb(galleryIndex);
        $('.rw2-product-gallery',component)?.classList.toggle('rw2-gallery--single',galleryItems.length<2);
        fitCutouts(galleryItems[galleryIndex].parentElement||component);
      }
      function syncGallery(preferredId) {
        const selectedColour=colourMeta(colorIndex>=0?selection[colorIndex]:'');
        const assignedIds=new Map();
        variants.forEach(v=>{if(v.featured_image?.id && colorIndex>=0){let set=assignedIds.get(String(v.featured_image.id));if(!set){set=new Set();assignedIds.set(String(v.featured_image.id),set);}set.add(v.options[colorIndex]);}});
        const colors=colorIndex>=0?[...new Set(variants.map(v=>v.options[colorIndex]))]:[];
        galleryItems=allSlides.filter(slide=>{
          if(colorIndex<0)return true;
          const owned=(slide.dataset.variantColours||'').split('|').filter(Boolean);
          if(owned.length&&!owned.includes(selection[colorIndex]))return false;
          const media=(product.media||[]).find(m=>String(m.id)===slide.dataset.mediaId);
          const related=assignedIds.get(slide.dataset.mediaId)||assignedIds.get(String(media?.preview_image?.id));
          if(related && !related.has(selection[colorIndex]))return false;
          const alt=(slide.dataset.alt||'').toLowerCase();
          const prefix=alt.split('|')[0].trim();
          const tagged=colors.find(c=>colourMeta(c).aliases.includes(prefix));
          return !tagged || colourMeta(tagged).name===selectedColour.name;
        });
        if(!galleryItems.length) galleryItems=allSlides.filter(s=>!(s.dataset.alt||'').includes('|'));
        const thumbs=$('.rw2-gallery-thumbs',component);thumbs.replaceChildren();
        galleryItems.forEach((slide,i)=>{
          const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`View image ${i+1}: ${slide.dataset.alt||'Product view'}`);
          const img=$('img',slide);if(img){const thumbnail=img.cloneNode();thumbnail.removeAttribute('srcset');thumbnail.removeAttribute('sizes');thumbnail.removeAttribute('id');thumbnail.alt='';thumbnail.loading='lazy';button.append(thumbnail);}
          if(slide.classList.contains('is-cutout')){button.classList.add('is-cutout');button.dataset.rw2Fit='';button.dataset.rw2FitMargin='0.1';}
          button.addEventListener('click',()=>showSlide(i));thumbs.append(button);
        });
        const preferred=galleryItems.findIndex(s=>s.dataset.mediaId===String(preferredId));
        showSlide(preferred>=0?preferred:0);
        requestAnimationFrame(()=>fitCutouts(thumbs));
      }
      $('[data-rw2-gallery-prev]',component)?.addEventListener('click',()=>showSlide(galleryIndex-1));
      $('[data-rw2-gallery-next]',component)?.addEventListener('click',()=>showSlide(galleryIndex+1));
      $('.rw2-gallery-main',component)?.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'){e.preventDefault();showSlide(galleryIndex-1);}else if(e.key==='ArrowRight'){e.preventDefault();showSlide(galleryIndex+1);}});
      let touchStart;const track=$('.rw2-gallery-track',component);
      track?.addEventListener('touchstart',e=>{touchStart=e.changedTouches[0].screenX;},{passive:true});
      track?.addEventListener('touchend',e=>{if(touchStart==null)return;const delta=e.changedTouches[0].screenX-touchStart;if(Math.abs(delta)>55)showSlide(galleryIndex+(delta<0?1:-1));touchStart=null;},{passive:true});
      function matches(v, excluded=-1) {return selection.every((value,i)=>i===excluded||value==null||v.options[i]===value);}
      function updateURL(variant) {if(!variant)return;const u=new URL(location.href);u.searchParams.set('variant',variant.id);history.replaceState({variantId:variant.id},'',u);}
      function update({colourChanged=false,initialRender=false}={}) {
        chosen=selection.every(v=>v!=null)?variants.find(v=>matches(v)):null;
        const priceVariant=chosen||variants.find(v=>matches(v)&&v.available)||variants.find(v=>matches(v))||initial;
        $('[data-rw2-price]',component).textContent=money(priceVariant.price);
        const stickyPrice=$('[data-rw2-sticky-price]',component);if(stickyPrice)stickyPrice.textContent=money(priceVariant.price);
        const compare=$('[data-rw2-compare-price]',component);compare.hidden=!(priceVariant.compare_at_price>priceVariant.price);compare.textContent=compare.hidden?'':money(priceVariant.compare_at_price);
        groups.forEach(group=>{
          const index=Number(group.dataset.rw2Option);
          $$('button[data-value]',group).forEach(button=>{
            const value=button.dataset.value;
            // Colour remains switchable even if the current size sells out in that colour.
            const available=variants.some(v=>(pre||v.available)&&v.options[index]===value&&(index===colorIndex||matches(v,index)));
            button.disabled=!available;
            button.setAttribute('aria-pressed',String(selection[index]===value));
            const stockLabel=$('[data-rw2-stock-label]',button);if(stockLabel)stockLabel.textContent=available||pre?'':'Sold out';
            if(index===colorIndex){const meta=colourMeta(value);$('[data-rw2-option-label]',button).textContent=meta.name;button.style.setProperty('--swatch',meta.swatch);button.title=`${meta.name}${meta.description?' — '+meta.description:''}`;}
          });
        });
        const label=$('[data-rw2-colour-label]',component);
        if(label&&colorIndex>=0){const m=colourMeta(selection[colorIndex]);label.textContent=m.name+(m.description?' — '+m.description:'');}
        else if(label){const sibling=$('.rw2-sibling-colours .is-selected',component);if(sibling)label.textContent=sibling.dataset.colourName;}
        variantInput.disabled=!chosen?.available;variantInput.value=chosen?.id||'';
        const allSoldOut=!variants.some(v=>v.available&&(colorIndex<0||v.options[colorIndex]===selection[colorIndex]));
        if(addButton){addButton.disabled=allSoldOut||Boolean(chosen&&!chosen.available)||busy;
        $('span',addButton).textContent=busy?'ADDING…':allSoldOut||chosen&&!chosen.available?'SOLD OUT':'ADD TO BAG';}
        if(stock)stock.textContent=pre?'':chosen?(chosen.available?'In stock':'This option is sold out.'):(allSoldOut?'This colour is currently sold out.':'');
        if(!initialRender) updateURL(chosen||priceVariant);
        if(colourChanged||initialRender)syncGallery(priceVariant.featured_media?.id||priceVariant.featured_image?.id);
      }
      groups.forEach(group=>group.addEventListener('click',event=>{
        const button=event.target.closest('button[data-value]');if(!button||button.disabled)return;
        const index=Number(group.dataset.rw2Option);selection[index]=button.dataset.value;
        if(index===colorIndex&&sizeIndex>=0&&selection[sizeIndex]!=null&&!variants.some(v=>v.available&&matches(v)))selection[sizeIndex]=null;
        error.hidden=true;update({colourChanged:index===colorIndex});
      }));
      const selectRequired=()=>{
        const missing=groups.find(g=>selection[Number(g.dataset.rw2Option)]==null);
        if(missing){error.textContent=Number(missing.dataset.rw2Option)===sizeIndex?'Please select a size before adding to your bag.':'Please select all product options before adding to your bag.';error.hidden=false;missing.scrollIntoView({behavior:reduced.matches?'auto':'smooth',block:'center'});$('button:not(:disabled)',missing)?.focus({preventScroll:true});return false;}
        return Boolean(chosen?.available);
      };
      form.addEventListener('submit',async event=>{
        event.preventDefault();if(pre||busy)return;if(!selectRequired())return;
        busy=true;error.hidden=true;update();
        try{
          const response=await fetch(component.dataset.addUrl,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:chosen.id,quantity:1}]}),credentials:'same-origin'});
          const result=await response.json();if(!response.ok)throw new Error(result.description||'This option could not be added. Please check availability and try again.');
          // Show the "Added to your bag" panel; fall back to the bag page if anything about it is unavailable.
          const shown=await showAdded((result.items&&result.items[0])||result,money);
          if(!shown){window.location.assign(component.dataset.cartUrl);return;}
          busy=false;update();
        }catch(err){error.textContent=err.message||'Something went wrong. Please try again.';error.hidden=false;busy=false;update();}
      });
      $('[data-rw2-sticky-add]',component)?.addEventListener('click',()=>{if(selectRequired())form.requestSubmit();});
      const sticky=$('.rw2-sticky-buy',component);
      if(sticky){
        let queued=false;
        const positionSticky=()=>{queued=false;const hidden=addButton.getBoundingClientRect().bottom>0;if(sticky.hidden!==hidden)sticky.hidden=hidden;};
        const requestPosition=()=>{if(!queued){queued=true;requestAnimationFrame(positionSticky);}};
        window.addEventListener('scroll',requestPosition,{passive:true});document.addEventListener('scroll',requestPosition,{passive:true,capture:true});window.addEventListener('resize',requestPosition);positionSticky();
      }
      update({initialRender:true});
    });
  }
  async function showAdded(item,money){
    const panel=document.getElementById('rw2-added');
    if(!panel||!item||typeof panel.showModal!=='function')return false;
    let cart;
    try{const res=await fetch(panel.dataset.cartJs||'/cart.js',{headers:{Accept:'application/json'},credentials:'same-origin'});if(!res.ok)return false;cart=await res.json();}catch{return false;}
    const esc=t=>String(t??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    const img=(item.featured_image&&item.featured_image.url)||item.image||'';
    const src=img?img+(img.includes('?')?'&':'?')+'width=360':'';
    const cut=/\.png(\?|$)/i.test(img);
    const opts=(item.options_with_values||[]).filter(o=>!(o.name==='Title'&&o.value==='Default Title')).map(o=>`<span>${esc(optionLabel(o.name))}: ${esc(o.value)}</span>`).join('');
    const linePrice=item.final_line_price??((item.final_price??item.price)*(item.quantity||1));
    $('[data-rw2-added-item]',panel).innerHTML=`<a class="rw2-added-media${cut?' is-cutout':''}" href="${esc(item.url)}"${cut?' data-rw2-fit data-rw2-fit-margin="0.1"':''}>${src?`<img src="${esc(src)}" alt="" width="180" height="180">`:''}</a><div class="rw2-added-info"><p class="rw2-added-name"><a href="${esc(item.url)}">${esc(item.product_title||item.title)}</a></p>${opts?`<p class="rw2-added-opts">${opts}</p>`:''}<p class="rw2-added-qty">Qty ${esc(item.quantity||1)}</p></div><p class="rw2-added-price">${money(linePrice)}</p>`;
    const free=Number(panel.dataset.freeFrom)||0, total=Number(cart.total_price)||0, remaining=free-total;
    const progress=$('[data-rw2-added-progress]',panel), bar=$('[data-rw2-added-bar]',panel);
    if(free>0){progress.innerHTML=remaining>0?`You’re <strong>${money(remaining)}</strong> away from free UK delivery.`:'<strong>Your bag qualifies for free UK delivery.</strong>';bar.style.width=`${Math.min(100,Math.round(total/free*100))}%`;}
    else progress.closest('.rw2-added-progress').hidden=true;
    const count=Number(cart.item_count)||0;
    $('[data-rw2-added-count]',panel).textContent=`(${count} ${count===1?'item':'items'})`;
    $('[data-rw2-added-subtotal]',panel).textContent=money(cart.items_subtotal_price??total);
    $$('[data-rw2-cart-count]').forEach(el=>{el.textContent=count;el.closest('a')?.setAttribute('aria-label',`Bag, ${count} items`);});
    openDialog('rw2-added');
    requestAnimationFrame(()=>fitCutouts(panel));
    return true;
  }
  // Click-to-play videos: the video is only created when the visitor presses play, so it never autoplays or downloads early.
  function initPlayers(root=document){
    $$('[data-rw2-player]',root).forEach(player=>{
      if(player.dataset.rw2Ready)return;player.dataset.rw2Ready='true';
      const button=$('[data-rw2-player-play]',player),tpl=$('template[data-rw2-player-src]',player);
      if(!button||!tpl)return;
      button.addEventListener('click',()=>{
        const video=tpl.content.querySelector('video')?.cloneNode(true);if(!video)return;
        video.removeAttribute('autoplay');video.setAttribute('playsinline','');video.controls=true;video.preload='auto';
        $$('[data-rw2-player] video').forEach(v=>v.pause());
        player.classList.add('is-playing');button.replaceWith(video);
        const p=video.play();if(p&&p.catch)p.catch(()=>{});
        video.focus({preventScroll:true});
      });
    });
  }
  function initContact(root=document){
    $$('.rw2-contact-form',root).forEach(form=>{
      if(form.dataset.rw2Ready)return;form.dataset.rw2Ready='true';
      const update=()=>{
        const topic=$('[data-rw2-topic]',form)?.value||'Website enquiry';
        const order=$('[data-rw2-order]',form)?.value.trim();
        let group='SUPPORT',email='support@rillwag.com';
        if(topic==='Returns & Exchanges'){group='RETURNS';email='returns@rillwag.com';}
        if(topic==='Wholesale / Stockist'){group='TRADE';email='sales@rillwag.com';}
        if(['Press & Partnerships','Other'].includes(topic)){group='GENERAL';email='hello@rillwag.com';}
        const subject=$('[data-rw2-subject]',form);if(subject)subject.value=`[RILLWAG ${group}] ${topic}${order?' — '+order:''}`;
        const routing=$('[data-rw2-routing]',form);if(routing)routing.value=email;
      };form.addEventListener('change',update);form.addEventListener('input',update);form.addEventListener('submit',update);update();
    });
  }
  function popupBlocked(){
    if($('dialog[open]'))return true;
    const banners=$$('#shopify-pc__banner,.shopify-pc__banner,[data-cookie-banner]');
    return banners.some(el=>{const r=el.getBoundingClientRect();return r.width>0&&r.height>0&&getComputedStyle(el).visibility!=='hidden';});
  }
  function initPopup(){
    const root=$('[data-rw2-popup-root]');if(!root||root.dataset.rw2Ready)return;root.dataset.rw2Ready='true';
    const dialog=$('#rw2-welcome',root),mini=$('.rw2-mini-offer',root);
    let subscribed=storage('localStorage','rw2.subscribed')==='1';
    const success=$('[data-rw2-subscribed]');
    if(success){subscribed=true;storage('localStorage','rw2.subscribed','1');mini.hidden=true;
      if(storage('sessionStorage','rw2.signup-source')==='popup'){openDialog(dialog.id);setTimeout(()=>dialog.close(),4500);}
      storage('sessionStorage','rw2.signup-source','');
    }
    $$('.rw2-newsletter-form').forEach(form=>form.addEventListener('submit',()=>{
      if(form.checkValidity())storage('sessionStorage','rw2.signup-source',form.closest('#rw2-welcome')?'popup':'footer');
    }));
    if(root.dataset.existingCustomer==='true')return;
    if(subscribed){mini.hidden=true;return;}
    const miniOff=()=>storage('sessionStorage','rw2.mini-hidden')==='1';
    $('[data-rw2-mini-close]',root)?.addEventListener('click',()=>{storage('sessionStorage','rw2.mini-hidden','1');mini.hidden=true;});
    dialog.addEventListener('close',()=>{if(!subscribed){storage('sessionStorage','rw2.welcome-dismissed','1');mini.hidden=miniOff()||popupBlocked();}});
    let syncQueued=false;
    const syncMini=()=>{syncQueued=false;if(!subscribed&&storage('sessionStorage','rw2.welcome-dismissed')==='1'){const hidden=miniOff()||popupBlocked();if(mini.hidden!==hidden)mini.hidden=hidden;}};
    const observer=new MutationObserver(()=>{if(!syncQueued){syncQueued=true;requestAnimationFrame(syncMini);}});
    observer.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['open','hidden','style','class']});
    if(storage('sessionStorage','rw2.welcome-dismissed')==='1'){syncMini();return;}
    if(root.dataset.designMode==='true')return;
    let attempts=0;
    const show=()=>{if(subscribed)return;if(popupBlocked()){if(attempts++<120)setTimeout(show,1000);return;}openDialog(dialog.id);};
    setTimeout(show,Number(root.dataset.delay)||8000);
  }
  let privacyPromise;
  function loadPrivacy(){
    if(window.Shopify?.customerPrivacy)return Promise.resolve(window.Shopify.customerPrivacy);
    if(privacyPromise)return privacyPromise;
    privacyPromise=new Promise((resolve,reject)=>{
      const timeout=setTimeout(()=>reject(new Error('Cookie settings could not be loaded. Please try again.')),8000);
      if(!window.Shopify?.loadFeatures){clearTimeout(timeout);reject(new Error('Cookie settings are not available yet. Please try again.'));return;}
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{clearTimeout(timeout);if(error||!window.Shopify.customerPrivacy)reject(new Error('Cookie settings could not be loaded. Please try again.'));else resolve(window.Shopify.customerPrivacy);});
    }).catch(err=>{privacyPromise=null;throw err;});return privacyPromise;
  }
  document.addEventListener('click',async event=>{
    const trigger=event.target.closest('[data-rw2-cookie]');if(!trigger)return;
    event.preventDefault();
    if(window.privacyBanner?.showPreferences){try{await window.privacyBanner.showPreferences();return;}catch{/* Use the same Shopify consent API if the native banner cannot open. */}}
    openDialog('rw2-privacy',trigger);const error=$('[data-rw2-privacy-error]');error.hidden=true;
    const form=$('[data-rw2-privacy-form]');$('button[type=submit]',form).disabled=true;
    try{const api=await loadPrivacy();const consent=api.currentVisitorConsent();['preferences','analytics','marketing'].forEach(key=>form.elements[key].checked=consent[key]==='yes');$('button[type=submit]',form).disabled=false;}
    catch(err){error.textContent=err.message;error.hidden=false;}
  });
  document.addEventListener('submit',async event=>{
    const form=event.target.closest('[data-rw2-privacy-form]');if(!form)return;event.preventDefault();
    const error=$('[data-rw2-privacy-error]',form),submit=$('button[type=submit]',form);submit.disabled=true;error.hidden=true;
    try{const api=await loadPrivacy();const consent={};['preferences','analytics','marketing'].forEach(key=>consent[key]=form.elements[key].checked);
      await new Promise((resolve,reject)=>{const timeout=setTimeout(()=>reject(new Error('Your preference could not be saved. Please try again.')),8000);api.setTrackingConsent(consent,result=>{clearTimeout(timeout);if(result?.error)reject(new Error('Your preference could not be saved. Please try again.'));else resolve();});});
      $('#rw2-privacy').close();
    }catch(err){error.textContent=err.message;error.hidden=false;}finally{submit.disabled=false;}
  });
  function initFitFinder(root=document){
    $$('[data-rw2-fit-finder]',root).forEach(box=>{
      if(box.dataset.rw2Ready)return;box.dataset.rw2Ready='true';
      const back=$('[data-rw2-fit-back]',box),chest=$('[data-rw2-fit-chest]',box),out=$('[data-rw2-fit-result]',box);
      if(!back||!chest||!out)return;
      const rows=$$('tbody tr[data-size]',box).map(r=>({el:r,size:r.dataset.size,bmin:+r.dataset.backMin,bmax:+r.dataset.backMax,cmin:+r.dataset.chestMin,cmax:+r.dataset.chestMax}));
      const initial=out.innerHTML;
      const update=()=>{
        const b=parseFloat(back.value),c=parseFloat(chest.value);
        rows.forEach(r=>r.el.classList.remove('is-match'));
        out.classList.remove('is-found','is-none');
        if(!(b>0)){out.innerHTML=initial;return;}
        let fit=rows.filter(r=>b>=r.bmin&&b<=r.bmax);
        if(c>0)fit=fit.filter(r=>c>=r.cmin&&c<=r.cmax);
        fit.forEach(r=>r.el.classList.add('is-match'));
        if(!(c>0)){
          out.innerHTML=fit.length?`By back length: <strong>${fit.map(r=>r.size).join(' or ')}</strong>. Add the chest girth to confirm.`:'This back length is outside our size range. Ask us about fit and we will help.';
          return;
        }
        if(fit.length===1){out.classList.add('is-found');out.innerHTML=`Your size: <strong>${fit[0].size}</strong>`;}
        else if(fit.length>1){out.classList.add('is-found');out.innerHTML=`Between <strong>${fit[0].size}</strong> and <strong>${fit[fit.length-1].size}</strong>. Choose ${fit[0].size} for a closer fit, or ${fit[fit.length-1].size} for more room.`;}
        else{
          out.classList.add('is-none');
          const minB=Math.min(...rows.map(r=>r.bmin)),maxB=Math.max(...rows.map(r=>r.bmax));
          const byBack=rows.filter(r=>b>=r.bmin&&b<=r.bmax);
          if(b>maxB)out.innerHTML=`This back length is longer than our largest size (${maxB} cm). Ask us about fit before ordering.`;
          else if(b<minB)out.innerHTML=`This back length is shorter than our smallest size (${minB} cm). Ask us about fit before ordering.`;
          else out.innerHTML=`The back fits <strong>${byBack.map(r=>r.size).join(' or ')}</strong>, but the chest is outside that range. Measure the chest again, or ask us about fit before ordering.`;
        }
      };
      back.addEventListener('input',update);chest.addEventListener('input',update);
    });
  }
  function initSearch(){
    const panel=$('[data-rw2-search]'),opener=$('[data-rw2-search-open]');
    if(!panel||!opener||panel.dataset.rw2Ready)return;panel.dataset.rw2Ready='true';
    const header=panel.closest('[data-rw2-header]'),input=$('[data-rw2-search-input]',panel),clear=$('[data-rw2-search-clear]',panel),closeBtn=$('[data-rw2-search-close]',panel);
    const grid=$('[data-rw2-search-results]',panel),label=$('[data-rw2-search-label]',panel),all=$('[data-rw2-search-all]',panel);
    const popular=grid.innerHTML,popularLabel=label.textContent;
    const scrim=document.createElement('div');scrim.className='rw2-search-scrim';document.body.appendChild(scrim);
    const fmt=v=>{try{return new Intl.NumberFormat(panel.dataset.locale||'en',{style:'currency',currency:panel.dataset.currency||'GBP'}).format(+v);}catch{return v;}};
    const esc=t=>String(t??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
    let open=false,timer,controller,closeTimer;
    const show=()=>{
      if(open)return;open=true;clearTimeout(closeTimer);
      panel.hidden=false;panel.classList.remove('is-closing');void panel.offsetHeight;
      panel.classList.add('is-open');scrim.classList.add('is-visible');header?.classList.add('is-search-open');
      opener.setAttribute('aria-expanded','true');
      setTimeout(()=>input.focus({preventScroll:true}),120);
      setTimeout(()=>fitCutouts(panel),80);
    };
    const hide=()=>{
      if(!open)return;open=false;
      panel.classList.remove('is-open');panel.classList.add('is-closing');scrim.classList.remove('is-visible');
      opener.setAttribute('aria-expanded','false');
      closeTimer=setTimeout(()=>{panel.hidden=true;panel.classList.remove('is-closing');header?.classList.remove('is-search-open');},600);
    };
    const empty=$('[data-rw2-search-empty]',panel);
    const SYN={jacket:['raincoat','coat','jacket'],jackets:['raincoat','coat','jacket'],coat:['coat'],coats:['coat'],mac:['raincoat'],macs:['raincoat'],grey:['grey','silver','stone'],gray:['grey','silver','stone'],silver:['silver','grey','stone'],green:['olive','moorland','green'],olive:['olive','moorland'],khaki:['olive','moorland'],white:['white','cloud'],cream:['white','cloud'],ivory:['white','cloud']};
    const norm=t=>String(t??'').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g,'').replace(/<[^>]*>/g,' ').replace(/&[a-z#0-9]+;/g,' ');
    const forms=w=>{const f=[w];if(w.length>4&&w.endsWith('es'))f.push(w.slice(0,-2));if(w.length>3&&w.endsWith('s'))f.push(w.slice(0,-1));return f.concat(SYN[w]||[]);};
    const matches=(q,p)=>{
      const hay=norm([p.title,p.handle,p.type,p.product_type,p.vendor,(p.tags||[]).join(' '),p.body].join(' '));
      return norm(q).split(/[^a-z0-9]+/).filter(w=>w.length>1).every(w=>forms(w).some(f=>hay.includes(f)));
    };
    const card=p=>{const img=(p.featured_image&&p.featured_image.url)||p.image||'';const src=img?img+(img.includes('?')?'&':'?')+'width=600':'';
      return `<a class="rw2-search-card${/\.png(\?|$)/i.test(img)?' is-cutout" data-rw2-fit data-rw2-fit-margin="0.1':''}" href="${esc(p.url)}"><div class="rw2-media" style="--media-ratio:4/5">${src?`<img src="${esc(src)}" alt="${esc(p.title)}" loading="lazy">`:''}</div><span class="rw2-search-card-title">${esc(p.title)}</span><span class="rw2-search-card-price">${esc(fmt(p.price))}</span></a>`;};
    const reset=()=>{grid.classList.remove('is-loading');empty.hidden=true;grid.innerHTML=popular;label.textContent=popularLabel;all.hidden=true;requestAnimationFrame(()=>fitCutouts(grid));};
    const render=(q,products)=>{
      grid.classList.remove('is-loading');
      const found=products.filter(p=>matches(q,p)).slice(0,4);
      if(!found.length){
        empty.hidden=false;empty.innerHTML=`Nothing matched “${esc(q)}”. Check the spelling, or try a broader word such as <button type="button" class="rw2-search-suggest" data-rw2-search-try="raincoat">raincoat</button>.`;
        label.textContent=popularLabel;grid.innerHTML=popular;all.hidden=true;requestAnimationFrame(()=>fitCutouts(grid));return;
      }
      empty.hidden=true;label.textContent='Products';grid.innerHTML=found.map(card).join('');requestAnimationFrame(()=>fitCutouts(grid));
      all.hidden=false;all.href=`${panel.dataset.searchUrl||'/search'}?q=${encodeURIComponent(q)}&options%5Bprefix%5D=last`;
      all.textContent=`View all results for “${q}” →`;
    };
    const query=()=>{
      const q=input.value.trim();clear.hidden=!input.value;
      clearTimeout(timer);controller?.abort();
      if(q.length<2){reset();return;}
      grid.classList.add('is-loading');
      timer=setTimeout(async()=>{
        controller=new AbortController();
        try{
          const url=`${panel.dataset.suggestUrl||'/search/suggest'}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=last`;
          const res=await fetch(url,{signal:controller.signal});const data=await res.json();
          render(q,data?.resources?.results?.products||[]);
        }catch(err){if(err.name!=='AbortError')render(q,[]);}
      },220);
    };
    opener.addEventListener('click',e=>{e.preventDefault();open?hide():show();});
    closeBtn.addEventListener('click',hide);scrim.addEventListener('click',hide);
    clear.addEventListener('click',()=>{input.value='';query();input.focus();});
    input.addEventListener('input',query);
    empty.addEventListener('click',e=>{const t=e.target.closest('[data-rw2-search-try]');if(!t)return;input.value=t.dataset.rw2SearchTry;query();input.focus();});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&open){hide();opener.focus();}});
  }
  function initCart(root=document){
    $$('[data-rw2-cart]',root).forEach(form=>{
      if(form.dataset.rw2Ready)return;form.dataset.rw2Ready='true';
      let timer;const submit=()=>{clearTimeout(timer);timer=setTimeout(()=>{form.classList.add('is-updating');const f=document.createElement('input');f.type='hidden';f.name='update';f.value='1';form.append(f);form.submit();},450);};
      $$('[data-rw2-qty]',form).forEach(box=>{
        const input=$('input',box);
        $$('[data-rw2-qty-step]',box).forEach(btn=>btn.addEventListener('click',()=>{const v=Math.max(0,(parseInt(input.value,10)||0)+parseInt(btn.dataset.rw2QtyStep,10));input.value=v;submit();}));
        input.addEventListener('change',submit);
      });
    });
  }
  function init(root=document){initPlayers(root);initDialogs(root);initHeader();initReveals(root);initProduct(root);initContact(root);initFitFinder(root);initSearch();initPopup();initCart(root);fitCutouts(root);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:select',e=>{if(e.target.querySelector('[data-rw2-popup-root]'))openDialog('rw2-welcome');});
  document.addEventListener('shopify:section:deselect',e=>e.target.querySelector('#rw2-welcome')?.close());
})();
